import styled from 'styled-components';
import { Typography, Link } from '@material-ui/core';

export const StyledContainer = styled.article`
	width: 100%;

	div {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}

	${props => props.theme.breakpoints.up('xs')} {
		width: 90%;
		border-top: 0px;
		margin: 0px 5%;
		padding-bottom: 6px;
	}
	${props => props.theme.breakpoints.up('sm')} {
		border-top: 1px solid #ffffff21;
		width: 90%;
		padding: 12px 0px;
		margin: 0px 5%;
	}
`;

export const StyledLink = styled(Link)`
	& {
		padding: 5px 10px;
		text-decoration: none !important;
		font-weight: 300;
		${props => props.theme.breakpoints.up('xs')} {
			padding: 5px 5px 8px 5px;
		}
	}
`;

export const Copyright = styled(Typography)`
	& {
		text-align: center;
		padding: 8px 0px 8px;
		font-size: 16px !important;
		padding-right: 5px;
	}
`;

export const Payment = styled(Typography)`
	text-align: center;
	padding: 8px 0px 8px;
	font-size: 16px;
	padding-right: 5px;
`;

export const Image = styled.img`
	max-height: 30px;
	max-width: 100px;
	margin-left: 12px;
`;

export const PaymentDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	${props => props.theme.breakpoints.down('sm')} {
		flex-direction: column;
		flex-wrap: wrap;
	}
`;
